import WebRTCSession from '../videocalling/WebRTCSession';
import WebRTCSignalingProvider from '../videocalling/WebRTCSignalingProvider';

export const CallSignalingModuleIdentifier = 'WebRTCVideoChat';

export enum CallSignalingType {
  CALL = 'call',
  ACCEPT = 'accept',
  REJECT = 'reject',
  STOP = 'hangUp',
  RESTART = 'iceRestart',
  RESTART_ACCEPT = 'iceRestartAccept',
  CANDIDATE = 'iceCandidates',
}
export enum CallSessionConnectionState {
  UNDEFINED = 0,
  CONNECTING = 1,
  CONNECTED = 2,
  FAILED = 3,
  DISCONNECTED = 4,
  CLOSED = 5,
  COMPLETED = 6,
}
export enum CallSessionState {
  NEW = 1,
  ACTIVE = 2,
  STOPPED = 3,
  REJECTED = 4,
  CLOSED = 5,
}
export enum CallType {
  VIDEO = 1,
  AUDIO = 2,
}
export enum CallEvent {
  CALL = 'call',
  ACCEPT = 'accept',
  REJECT = 'reject',
  STOP = 'stop',
  INVALID = 'invalid',
  NOT_ANSWER = 'not-answer',
  REMOTE_STREAM = 'remote-stream',
  CONNECTION_STATE = 'connection-state',
  CLOSE = 'close',
  STATS_REPORT = 'stats-report',
  DEVICES = 'devices',
}
export enum PeerConnectionState {
  NEW = 1,
  CONNECTING = 2,
  CHECKING = 3,
  CONNECTED = 4,
  DISCONNECTED = 5,
  FAILED = 6,
  CLOSED = 7,
  COMPLETED = 8,
}

export namespace ConnectyCubeCalls {
  export type UserInfo = {
    maxBandwidth?: number;
    bandwidth?: number;
    [key: string]: any;
  };
  export type ExtensionParams = {
    callType?: CallType;
    callerID?: number;
    iceCandidates?: RTCIceCandidateInit[];
    opponentsIDs?: number[];
    userInfo?: UserInfo;
    sessionID?: string;
    [key: string]: any;
  };
  export type Session = WebRTCSession;
  export type SignalingProvider = WebRTCSignalingProvider;
  export type SessionParams = {
    ID: string | null;
    initiatorID: number;
    opponentsIDs: number[];
    callType: CallType;
    signalingProvider: SignalingProvider;
    currentUserID: number;
    maxBandwidth: number;
  };
  // Listeners
  export type OnCallListener = (session: Session, userInfo: UserInfo) => void;
  export type OnAcceptCallListener = (session: Session, userID: number, userInfo: UserInfo) => void;
  export type OnRejectCallListener = (session: Session, userID: number, userInfo: UserInfo) => void;
  export type OnStopCallListener = (session: Session, userID: number, userInfo: UserInfo) => void;
  export type OnInvalidEventsListener = (session: Session, userID: number, userInfo: UserInfo) => void;
  export type OnUserNotAnswerListener = (session: Session, userID: number) => void;
  export type OnRemoteStreamListener = (session: Session, userID: number, stream: MediaStream) => void;
  export type OnSessionConnectionStateChangedListener = (
    session: Session,
    userID: number,
    connectionState: CallSessionConnectionState
  ) => void;
  export type OnSessionCloseListener = (session: Session) => void;
  export type OnCallStatsReportListener = (session: Session, userID: number, stats: any, error: Error) => void;
  export type OnDevicesChangeListener = ((this: MediaDevices, ev: Event) => any) | ((ev: Event) => any);
  export type Listeners =
    | OnCallListener
    | OnAcceptCallListener
    | OnRejectCallListener
    | OnStopCallListener
    | OnInvalidEventsListener
    | OnUserNotAnswerListener
    | OnRemoteStreamListener
    | OnSessionConnectionStateChangedListener
    | OnSessionCloseListener
    | OnCallStatsReportListener
    | OnDevicesChangeListener;
  export type ListenerName =
    | 'onCallListener'
    | 'onAcceptCallListener'
    | 'onRejectCallListener'
    | 'onStopCallListener'
    | 'onInvalidEventsListener'
    | 'onUserNotAnswerListener'
    | 'onRemoteStreamListener'
    | 'onSessionConnectionStateChangedListener'
    | 'onSessionCloseListener'
    | 'onCallStatsReport'
    | 'onDevicesChangeListener';
}
